var file_upload_viewer_default = {
  "fontElementMap": "WId5U",
  "file_upload_container": "_0nWyp",
  "file_upload_link": "QhHy7",
  "file_upload_error_container": "_4oWG8",
  "file_upload_file_info": "_3mD9h",
  "file_upload_type_icon": "-xWo2",
  "file_upload_status_icon_container": "GC3M7",
  "file_upload_status_icon": "Oo0bM",
  "file_upload_description": "zQEXc",
  "file_upload_name_container": "SCFQT",
  "file_upload_name": "nqVHG",
  "file_upload_extension": "_3bocz",
  "file_loader_icon": "_4GR8Q",
  "file_upload_icon_frame": "QcxDg",
  "file_upload_icon_background": "_5Y-rU"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
